<template>
  <el-form
    class="source-form"
    :model="formSource"
    :rules="rules"
    ref="ruleFormAddCount"
    label-width="160px"
    :disabled="!edit"
  >
    <el-form-item label="认证源名称" prop="name">
      <el-input
        v-model.trim="formSource.name"
        placeholder="请输入认证源名称"
        disabled
      ></el-input>
    </el-form-item>
    <el-form-item label="是否启用" prop="enabled">
      <el-switch v-model="formSource.enabled"></el-switch>
    </el-form-item>
    <el-form-item label="CAS Server 登录地址" prop="casServerUrlPrefix">
      <el-input
        v-model.trim="formSource.casServerUrlPrefix"
        placeholder="请输入登录地址"
        @input="change($event)"
        :disabled="!add"
      ></el-input>
    </el-form-item>
    <el-form-item label="账户关联设置" class="contact-rule" prop="createMethod">
      <template>
        <el-radio v-model="formSource.createMethod" label="1">手动关联IDaaS账户</el-radio>
        <el-radio v-model="formSource.createMethod" label="0">自动创建IDaaS账户</el-radio>
      </template>
    </el-form-item>
    <el-form-item>
      <div v-show="edit" class="footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="handleCancel">取 消</el-button>
      </div>
    </el-form-item>
  </el-form>
</template>
<script>
import APIS from "@/apis/certificationSource.js"
export default {
  props: {
    formSource: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: true
    },
    add: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      realmName: this.$realm,
      rules: {
        name: [
          { required: false, message: "请输入认证源名称", trigger: "blur" }
        ],
        enabled: [
          { required: false, message: "是否启用", trigger: "blur" }
        ],
        casServerUrlPrefix: [
          { required: true, message: "请输入登录地址", trigger: "blur" }
        ],
        createMethod: [
          { required: true, message: "请选择关联规则", trigger: "blur" }
        ]
      }
    }
  },
  methods: {
    change() {
      this.$forceUpdate()
    },
    resetForm() {
      this.$refs["ruleFormAddCount"].resetFields()
    },
    validateForm() {
      let validate = false
      this.$refs["ruleFormAddCount"].validate((valid) => {
        if (valid) {
          validate = true
        }
      })
      return validate
    },
    handleCancel() {
      this.$refs["ruleFormAddCount"].resetFields()
      if (!this.add) {
        this.$emit("changeStatus", true)
      } else {
        this.$router.back(-1)
      }
    },
    submitForm() {
      this.addProvider()
    },
    // 获取认证源基本信息
    async addProvider() {
      if (!this.validateForm()) {
        return false
      }
      let params = this.formSource,
        poxName = "addCasProvider"
      if (!this.add) {
        poxName = "editCasProvider"
        params.secret == "******" ? (params.secret = null) : ""
      }
      let { status } = await APIS[poxName](
        this.realmName,
        {
          data: params
        },
        this.formSource.providerId
      )
      if (status === 0) {
        if (this.add) {
          this.$router.push({
            path: `/certificationSource`
          })
        } else {
          this.$emit("changeStatus")
        }
      } else {
        if (!this.add) {
          this.$emit("changeStatus", true)
        }
      }
    }
  }
}
</script>
<style lang="scss">
.source-form {
  width: 515px;
  .contact-rule {
    .el-form-item__content {
      display: flex;
      flex-direction: column;
      p {
        width: 150%;
      }
      label {
        margin: 5px 0;
        margin-left: 0px;
      }
    }
  }
}
</style>